const Permissions = {
    ACCESS_CLAUSELINK: 'access_clauselink',
    ARCHIVE_PROJECT_WORKSPACE: 'archive_project_workspace',
    BROWSE_CONTENT_LIBRARY: 'content_library_page',
    BROWSE_GRID_VIEW: 'grid_view_page',
    BROWSE_MULTI_DOCS: 'multi_doc_view_page',
    BROWSE_SINGLE_DOC: 'single_doc_view_page',
    CREATE_CLAUSE_COMMENTS: 'create_clause_comments',
    CREATE_COMPARISON_COMMENTS: 'create_comparison_comments',
    CREATE_DOCUMENT_COMPARISON: 'create_document_comparison',
    DELETE_PROJECT_WORKSPACE: 'delete_project_workspace',
    DOWNLOAD_DOCUMENT: 'download_document',
    EDIT_FILE_METADATA: 'edit_file_metadata',
    INITIAL_DEFAULT_LIMITED_ACCESS: 'initial_default_limited_access',
    MOVE_PROJECT_WORKSPACE: 'move_project_workspace',
    RENAME_PROJECT_WORKSPACE: 'rename_project_workspace',
    SEARCH_CLAUSES: 'search_clauses',
    SEARCH_DOCUMENTS: 'search_documents',
    UPDATE_COMPARISON_STATUS: 'update_comparison_status',
    UPLOAD_FILE: 'upload_file',
    VIEW_ACTIVITY_DETAILS: 'view_activity_details',
    VIEW_CLAUSE_DIFFS: 'view_clause_diffs',
    VIEW_CLAUSE_COMMENTS: 'view_clause_comments',
    VIEW_COMPARISON_CHECKLIST_ITEMS: 'view_comparison_checklist_items',
    VIEW_COMPARISON_COMMENTS: 'view_comparison_comments',
    VIEW_FILE_METADATA: 'view_file_metadata',
    VIEW_PARENT_DOCUMENTS: 'view_parent_documents',
    VIEW_PROJECT_WORKSPACE_DOCUMENT_COMPARISONS: 'view_project_workspace_document_comparisons',
    VIEW_PROJECT_WORKSPACE_DOCUMENTS: 'view_project_workspace_documents',
    VIEW_PROJECTS_WORKSPACE_PAGE: 'view_projects_workspace_page',
    VIEW_RECENT_ACTIVITIES: 'view_recent_activity',
    VIEW_RECENT_ACTIVITY_DOCUMENT_COMPARISONS: 'view_recent_activity_document_comparisons',
    VIEW_RECENT_ACTIVITY_DOCUMENTS: 'view_recent_activity_documents',
    VIEW_SAVED_SEARCH_PAGE: 'view_saved_search_page',
    VIEW_SIMILARITY_ALIGNMENT: 'view_similarity_alignment',
};
export default Permissions;
